import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Label, Input, Container, Tooltip } from 'reactstrap';
import { useParams, useLocation, Redirect } from 'react-router-dom';
import FormData from 'form-data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCamera, faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import _, { uniqueId } from 'lodash';
import DatePicker from 'react-datepicker';
import '../../assets/scss/react-datepicker.css';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import Lightbox from 'lightbox-react';
import Block from '../common/Display/Block';
import Translate, { t } from '../common/Translate';
import updateFinalPrice from '../../services/Finalising/updateFinalPrice';
import updateReportInspection from '../../services/Finalising/updateReportInspection';
import debrifeRecord from '../../services/Finalising/debriefRecord';
import useRecord from '../../Store/uses/useRecord';
import mapStateToProps from '../../Store/mapping/record/mapStateToProps';
import mapDispatchToProps from '../../Store/mapping/record/mapDispatchToProps';
import { REACT_APP_API, datesFormat, NRM_SUB_STATUS, countries, nrmFinalisationDocumentVar } from '../../config';
import ApiService from '../../services/api/ApiService';
import { calendarLang, country } from '../../language-context';
import { Auth, recordActions } from '../../config/configuration/react';
import imageLoading from '../../services/Image/imageLoading';
import { useGuaranteedPrice } from '../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import { currencySign } from '../../Utils/currencySign';
import Switch from '../Switch/Switch';

const Finalising = (props) => {
  const { recordId } = useParams();
  const location = useLocation();
  const { record, isRecordLoading, errorRecordApi, recordEntity } = useRecord(recordId);
  const [slide, setSlide] = useState(null);
  const [infoCar, setInfoCar] = useState('');
  const c2bOffer = _.get(record, 'supervisor.c2bOffer', 0);
  const dispatch = useDispatch();
  const source = recordEntity.getSourceInfos();
  const isNrmRecord = recordEntity.isNrmRecord();

  const listTitre = [
    { titre: 'proposition' },
    { titre: 'buy_immediately' },
    { titre: 'debrief' },
    { titre: 'trade_in_offer_tab' },
    { titre: 'debrief' },
  ];

  const getExternalRef = async () => {
    if (
      Auth.country() === 'IT' &&
      source.displayExternalRef === true &&
      (recordEntity.getExternalRef() === null || recordEntity.getExternalRef() === '')
    ) {
      const res = await dispatch(recordActions.getExternalRef(recordId));
      setInfoCar(res.externalRef);
    } else {
      setInfoCar(recordEntity.getExternalRef());
    }
  };

  useEffect(() => {
    if (isNrmRecord) {
      setSlide(4);
    } else {
      setSlide(0);
    }
    getExternalRef();
  }, []);

  location.state.from = `/files/${recordId}`;

  return (
    <Block {...props} backRoute={location.state.from} page={slide !== null && listTitre[slide].titre} showSubHeader>
      <div className="page">
        {(errorRecordApi && (
          <p className="ml-2 text-danger">
            <Translate code={errorRecordApi} />
          </p>
        )) || (
          <>
            {slide === 0 && (
              <div>
                <Col xs="12" sm="6" md="6" lg="4" className="c2bOffer-bloc mt-3">
                  <Row>
                    <Col xs="8" sm="6" lg="8">
                      {t('supervisor_price')}
                      <br />
                      <span className="info-bull">{t('conditions')}</span>
                    </Col>
                    <Col xs="4" sm="6" lg="4">
                      {c2bOffer > 0 && Math.round(c2bOffer)} <Translate code="€ TTC" />
                    </Col>
                  </Row>
                </Col>
                {Auth.country() === 'IT' && source.displayExternalRef === true && (
                  <Col xs="12" sm="4" md="3" lg="3" className="c2bOffer-bloc mt-3 text-center c2bOffer-float-right">
                    {t('externalRef')}
                    <br />
                    {t('infoCar')}: {infoCar !== '' ? infoCar : t('notAvailable')}
                  </Col>
                )}
                <hr />
              </div>
            )}
            {slide === 0 && <FinalisingPage {...props} setSlide={setSlide} data={record} />}
            {slide === 1 && (
              <AchatImmediatePage {...props} data={record} setSlide={setSlide} recordEntity={recordEntity} />
            )}
            {slide === 2 && <DebrifePage {...props} data={record} />}
            {slide === 3 && <TradeInOfferPage {...props} data={record} />}
            {slide === 4 && <NrmDebriefPage {...props} data={record} />}
          </>
        )}
        {slide > 0 && slide !== 4 && (
          <Row className="mt-5">
            <Col className="ml-3">
              <button
                type="button"
                className="btn btn-outline-secondary mb-3 text-uppercase"
                onClick={() => setSlide(0)}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </Col>
          </Row>
        )}
      </div>
      {isRecordLoading && (
        <div className="loader-full-screen main">
          <Spinner />
        </div>
      )}
    </Block>
  );
};

const FinalisingPage = ({ setSlide, data }) => {
  const comment = _.get(data, 'supervisor.comment', '');
  const handleClick = (id) => setSlide(id);

  return (
    <Container fluid>
      <Row className="mt-3">
        <Col xs={12} md={6} lg={5}>
          <Label className="text-primary text-uppercase font-weight-light text-left" for="comment">
            <Translate code="comment" />
          </Label>
          {comment}
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs="12" sm="6" lg="3" xl="3">
          <button type="button" className="btn btn-1 btn-block mb-2 text-uppercase" onClick={() => handleClick(1)}>
            {t('rebuy_immediately')}
          </button>
        </Col>
        <Col xs="12" sm="6" lg="3" xl="3">
          <button type="button" className="btn btn-2 btn-block mb-2 text-uppercase" onClick={() => handleClick(2)}>
            {t('client_dont_want_to_sell')}
          </button>
        </Col>
      </Row>
    </Container>
  );
};

FinalisingPage.propTypes = {
  setSlide: PropTypes.func.isRequired,
  data: PropTypes.shape().isRequired,
};

const AchatImmediatePage = ({ data, setSlide, recordEntity }) => {
  const finalPrice = _.get(data?.supervisor, 'c2bOffer', null);
  const comment = _.get(data?.expertise, 'comment', '');
  const userCountry = Auth.country();
  const recordKey = _.get(data?.record, 'recordKey', '');
  const displaySpoticarPdf = _.get(data, 'sourceInfos.displaySpoticarPdf', '');
  const showTradeInCta = ['FR', 'ES', 'IT', 'PT'];
  const isCarcheckRecord = !recordEntity.isNrmRecord();
  const handleOnClick = (id) => setSlide(id);
  const parseDateObject = (dateObject) => new Date(dateObject.date);
  const stockDateSuperVisor = _.get(data, 'supervisor', '');
  const inspectionDateObject = _.get(data?.record, 'createdAt', {});
  const inspectionDate = parseDateObject(inspectionDateObject);
  const registrationDateObject = _.get(data?.vehicle, 'registrationDate', {});
  const registrationDate = parseDateObject(registrationDateObject);
  const mileage = _.get(data?.vehicle, 'mileage', null);
  const numberOfDaysPassed = Math.floor((inspectionDate - registrationDate) / (1000 * 60 * 60 * 24));
  const numberOfDaysUntilEntry = Math.floor(
    (moment(stockDateSuperVisor.entryStockDate.date) - inspectionDate) / (1000 * 60 * 60 * 24),
  );
  const { recordId } = useParams();
  const [query, setQuery] = useState({
    recordId,
    finalPrice,
    comment,
  });
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [redirect, setRedirect] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    Object.entries(query).forEach((querie) => {
      if (querie[1] === '') {
        delete query[querie[0]];
      }
    });
  }, [query]);

  const handleChange = (e) => {
    const { id } = e.target;
    let { value } = e.target;
    if (['finalPrice'].includes(id)) {
      value = value.replace(',', '.').replace(/[^\d.\d]/g, '');
    }
    if (query) {
      const prev = { ...query };
      prev[id] = value;
      setQuery(prev);
    } else setQuery({ id: value });
  };

  const counterAppraisalDaysValidate = (record) => {
    const { enableCounterAppraisal, acceptDaysWithoutCa, createdAt, entryStockDate } = record || {};
    const difference = Math.abs(moment(createdAt?.date).diff(moment(entryStockDate), 'days'));
    return enableCounterAppraisal && difference > (acceptDaysWithoutCa || 7);
  };

  const { enableCounterAppraisal, acceptDaysWithoutCa, enableManualDecision } =
    data?.sourceInfos?.sourceGroupData || {};
  const { counterAppraisalRequired } = data?.supervisor || {};
  const activeCounterAppraisal =
    (enableCounterAppraisal && enableManualDecision && counterAppraisalRequired) ||
    (!enableManualDecision && enableCounterAppraisal);
  const handleClick = async () => {
    const { createdAt } = data?.expertise || {};
    const entryStockDate = stockDateSuperVisor?.entryStockDate?.date;
    setIsLoading(true);
    try {
      await updateFinalPrice(query);
      if (
        counterAppraisalDaysValidate({
          enableCounterAppraisal,
          createdAt,
          acceptDaysWithoutCa,
          entryStockDate,
        }) &&
        activeCounterAppraisal &&
        !Object.prototype.hasOwnProperty.call(data?.counterInspection, 'recordId')
      ) {
        await dispatch(recordActions.updateStatus(recordId, 'waiting-for-counter-appraisal'));
      } else {
        await dispatch(recordActions.updateStatus(recordId, 'repurchase_account'));
      }
    } catch (e) {
      setError('Error ', e);
    } finally {
      setIsLoading(false);
      setRedirect(`/files/${recordId}`);
    }
  };

  return (
    <Container fluid>
      <Row className="mt-3">
        <Col xs={12} md={5} lg={4}>
          <Label className="text-primary text-uppercase font-weight-light text-left" for="finalPrice">
            <Translate code="vo_price" />
          </Label>
          <div className="input-finalPrice">
            <Input
              type="text"
              name="finalPrice"
              id="finalPrice"
              className="rounded mr-3"
              onChange={(e) => handleChange(e)}
              value={query.finalPrice && query.finalPrice.replace('.', ',')}
              disabled={Auth.roleViewerAccess() || recordEntity.finalisationReadOnlyStatus()}
            />
            <span>
              <Translate code="€ TTC" />
            </span>
          </div>
        </Col>
      </Row>
      {activeCounterAppraisal && (
        <>
          <Row className="pb-3">
            <Col>
              <font className="text-primary text-left text-bold pl-2" size="3">
                {t('expectedDeliveryDate')} :
              </font>
              <span className="text-primary text-left text-bold pl-2" size="3">
                <strong>{moment(stockDateSuperVisor.entryStockDate.date).format('DD.MM.YYYY')}</strong>
              </span>
            </Col>
          </Row>
          <Row className="pb-3">
            <Col>
              <font className="text-primary text-left text-bold pl-2" size="3">
                {t('maxMileage')} :
              </font>
              <span className="text-primary text-left text-bold pl-2" size="3">
                <strong>
                  {Math.round((mileage / numberOfDaysPassed) * numberOfDaysUntilEntry + mileage)}
                  {t('km')}
                </strong>
              </span>
            </Col>
          </Row>
        </>
      )}
      <Row className="mt-3">
        <Col xs={12} md={5} lg={4}>
          <Label className="text-primary text-uppercase font-weight-light text-left" for="comment">
            <Translate code="comment_finalizing" />
          </Label>
          <Input
            type="textarea"
            name="comment"
            id="comment"
            className="rounded"
            rows={4}
            onChange={(e) => handleChange(e)}
            value={query.comment && query.comment}
            disabled={Auth.roleViewerAccess() || recordEntity.finalisationReadOnlyStatus()}
          />
        </Col>
      </Row>
      {error && (
        <p className="ml-2 text-danger">
          <Translate code={error} />
        </p>
      )}
      <Row className="mt-3">
        <Col xs="12" md="5" lg="4">
          {isLoading && <Spinner size="sm" />}
          <button
            type="button"
            className={`btn btn-block mb-3 text-uppercase ${query.finalPrice > 0 ? 'btn-1' : 'btn-4'}`}
            onClick={() => handleClick()}
            disabled={_.get(query, 'finalPrice', null) === null || recordEntity.finalisationReadOnlyStatus()}
          >
            {t('validate')}
          </button>
        </Col>
      </Row>
      <Row className="mt-3">
        {showTradeInCta.includes(userCountry) && isCarcheckRecord && (
          <Col xs="12" md="5" lg="4">
            <button type="button" className="btn btn-3 btn-block mb-2 text-uppercase" onClick={() => handleOnClick(3)}>
              {t('trade_in_offer_cta')}
            </button>
          </Col>
        )}
      </Row>
      <Row className="mt-3">
        {displaySpoticarPdf && isCarcheckRecord && (
          <Col xs="12" md="5" lg="4">
            <a
              target="_blank"
              href={`${REACT_APP_API}/buyer/public/${recordKey}/admin-documents/spoticar-reprise.pdf`}
              className="btn btn-3 btn-block mb-2 text-uppercase"
              rel="noopener noreferrer"
              id="theHref"
            >
              <Translate code="spoticar_pdf_cta" />
            </a>
          </Col>
        )}
      </Row>
      {redirect && <Redirect to={redirect} />}
    </Container>
  );
};

AchatImmediatePage.propTypes = {
  data: PropTypes.shape().isRequired,
  setSlide: PropTypes.func.isRequired,
  recordEntity: PropTypes.shape().isRequired,
};

const DebrifePage = ({ data }) => {
  const reportType = _.get(data?.reportExpertise, 'reportId', null);
  const comment = _.get(data?.reportExpertise, 'reportComment', null);
  const desiredPrice = _.get(data?.reportExpertise, 'desiredPrice', null);
  const negotiatedPrice = _.get(data?.reportExpertise, 'negotiatedPrice', null);
  const { recordId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState({
    recordId,
    reportType,
    comment,
    desiredPrice,
    negotiatedPrice,
  });
  const [error, setError] = useState();
  const [redirect, setRedirect] = useState();
  const [disabled, setDisabled] = useState(true);
  const dispatch = useDispatch();

  const unsetQuery = (id = null) => {
    Object.entries(query).forEach((q) => {
      if (q[1] === '' || (id === 'reportType' && q[0].startsWith('radio'))) delete query[q[0]];
      if (q[0] === 'reportType' && parseInt(q[1], 10) !== 1) delete query.desiredPrice;
    });
  };

  useEffect(() => {
    unsetQuery();
    if (
      parseInt(query.reportType, 10) === 1 &&
      query.desiredPrice > 0 &&
      query.negotiatedPrice > 0 &&
      query.comment &&
      _.trim(query.comment).length > 10
    ) {
      setDisabled(false);
    } else if (
      parseInt(query.reportType, 10) !== 1 &&
      query.negotiatedPrice > 0 &&
      query.comment &&
      _.trim(query.comment).length > 10
    )
      setDisabled(false);
    else setDisabled(true);
  }, [query]);

  const handleChange = (e) => {
    const { id } = e.target;
    let { value } = e.target;
    if (['desiredPrice', 'negotiatedPrice'].includes(id)) {
      value = value.replace(',', '.').replace(/[^\d.\d]/g, '');
    }
    if (id === 'reportType') unsetQuery(id);
    if (query) {
      const prev = { ...query };
      prev[id] = value;
      setQuery(prev);
    } else setQuery({ id: value });
  };

  const handleClick = async () => {
    try {
      await updateReportInspection(query);
      await dispatch(recordActions.updateStatus(recordId, 'report'));
      await debrifeRecord(recordId);
    } catch (e) {
      setError('Error ', e);
    } finally {
      setIsLoading(false);
      setRedirect(`/files/${recordId}`);
    }
  };

  return (
    <Container fluid>
      <Row className="page-Debrife mt-3">
        <Col xs={12} md={6} lg={8}>
          <Label className="text-primary text-uppercase text-left mb-3">
            <Translate code="choose_report_type" />
          </Label>
          <Label check className="mb-3">
            <Input
              type="radio"
              id="reportType"
              value="1"
              onChange={(e) => handleChange(e)}
              checked={parseInt(query.reportType, 10) === 1}
            />{' '}
            <span className="text-primary">
              <Translate code="reportType1" />
            </span>
          </Label>
          <Label check className="mb-3">
            <Input
              type="radio"
              id="reportType"
              value="2"
              onChange={(e) => handleChange(e)}
              checked={parseInt(query.reportType, 10) === 2}
            />{' '}
            <span className="text-primary">
              <Translate code="reportType2" />
            </span>
          </Label>
          <Label check className="mb-3">
            <Input
              type="radio"
              id="reportType"
              value="3"
              className={(query.radio3 && 'active') || 'none'}
              onChange={(e) => handleChange(e)}
              checked={parseInt(query.reportType, 10) === 3}
            />{' '}
            <span className="text-primary">
              <Translate code="reportType3" />
            </span>
          </Label>
          <Label check className="mb-3">
            <Input
              type="radio"
              id="reportType"
              value="4"
              onChange={(e) => handleChange(e)}
              checked={parseInt(query.reportType, 10) === 4}
            />{' '}
            <span className="text-primary">
              <Translate code="reportType4" />
            </span>
          </Label>
        </Col>
      </Row>
      <hr />
      <Row className="mt-3">
        <Col xs={12} md={5} lg={4}>
          <Label className="text-primary text-uppercase text-left" for="negotiatedPrice">
            <Translate code="price_for_client" />
          </Label>
          <div className="input-finalPrice">
            <Input
              type="text"
              name="negotiatedPrice"
              id="negotiatedPrice"
              className="rounded mr-3"
              onChange={(e) => handleChange(e)}
              value={(query.negotiatedPrice && query.negotiatedPrice.replace('.', ',')) || ''}
              disabled={Auth.roleViewerAccess()}
            />
            <span>
              <Translate code="€ TTC" />
            </span>
          </div>
        </Col>
      </Row>
      {parseInt(query.reportType, 10) === 1 && (
        <Row className="mt-3">
          <Col xs={12} md={5} lg={4}>
            <Label className="text-primary text-uppercase text-left" for="desiredPrice">
              <Translate code="client_price" />
            </Label>
            <div className="input-finalPrice">
              <Input
                type="text"
                name="desiredPrice"
                id="desiredPrice"
                className="rounded mr-3"
                onChange={(e) => handleChange(e)}
                value={(query.desiredPrice && query.desiredPrice.replace('.', ',')) || ''}
                disabled={Auth.roleViewerAccess()}
              />
              <span>
                <Translate code="€ TTC" />
              </span>
            </div>
          </Col>
        </Row>
      )}
      <hr />
      <Row className="mt-3">
        <Col xs={12} md={5} lg={4}>
          <Label className="text-primary text-uppercase text-left" for="comment">
            <Translate code="comment_debrief" />
          </Label>
          <Input
            type="textarea"
            name="comment"
            id="comment"
            className="rounded"
            rows={4}
            onChange={(e) => handleChange(e)}
            value={(query.comment && query.comment) || ''}
            disabled={Auth.roleViewerAccess()}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        {error && (
          <p className="ml-2 text-danger">
            <Translate code={error} />
          </p>
        )}
        <Col xs={12} md={5} lg={4}>
          {isLoading && <Spinner size="sm" />}
          <button
            type="button"
            className={`btn btn-block mb-3 text-uppercase ${disabled ? 'btn-4' : 'btn-1'}`}
            onClick={() => handleClick()}
            disabled={disabled}
          >
            {t('validate')}
          </button>
        </Col>
      </Row>
      {redirect && <Redirect to={redirect} />}
    </Container>
  );
};

DebrifePage.propTypes = {
  data: PropTypes.shape().isRequired,
};

const ClientInfoList = [
  {
    name: 'client_firstname',
    titre: 'firstName',
    placeholder: 'Placeholder_firstname',
    type: 'text',
    pattern: '[A-Za-z]',
    mode: 'text',
  },
  {
    name: 'client_lastname',
    titre: 'name',
    placeholder: 'Placeholder_lastname',
    type: 'text',
    pattern: '[A-Za-z]',
    mode: 'text',
  },
  {
    name: 'client_email',
    titre: 'email',
    placeholder: 'Placeholder_email',
    type: 'text',
    pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$',
    mode: 'email',
  },
  {
    name: 'client_phone',
    titre: 'phone',
    placeholder: 'Placeholder_phone',
    type: 'number',
    pattern: '[0-9]*',
    mode: 'tel',
  },
  {
    name: 'buyer_offer_pdf',
    titre: 'buyerOffer',
    placeholder: '2 000,500',
    type: 'text',
    // pattern: '[+-]?([0-9]*[,])?[0-9]+',
    mode: 'tel',
  },
];

const TradeInOfferPage = ({ data }) => {
  const { recordId } = useParams();
  const recordKey = _.get(data?.record, 'recordKey', '');
  const languageId = _.get(data?.record, 'countryId', 1);
  const clientInfo = _.get(data, 'customer', '');
  const offer =
    (_.get(data?.valuation, 'recoveryOffer') !== null && _.get(data?.valuation, 'recoveryOffer')) ||
    _.get(data?.supervisor, 'c2bOffer', '').toString();
  const originId = _.get(data?.record, 'originId', null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [infoChange, setInfoChange] = useState(false);
  const [comment, setComment] = useState(_.get(data?.valuation, 'recoveryOfferComment', ''));
  const [maxMileageEntryStockDate, setMaxMileageEntryStockDate] = useState(
    _.get(data?.valuation, 'maxMileageEntryStockDate', null),
  );
  const [hideReconCostsPdf, setHideReconCostsPdf] = useState(_.get(data?.supervisor, 'hideReconCostsPdf', false));
  const [b2cValuePdf, setB2cValuePdf] = useState(_.get(data?.supervisor, 'displayB2cValuePdf', false));
  const [useSpoticarPdfLayout, setUseSpoticarPdfLayout] = useState(
    _.get(data?.supervisor, 'useSpoticarPdfLayout', false),
  );
  const [useDsPdfLayout, setUseDsPdfLayout] = useState(_.get(data?.supervisor, 'useDsPdfLayout', false));
  const enableSpoticarPdfCta = _.get(data?.sourceInfos.sourceGroupData, 'enableSpoticarPdfCta', false);
  const enableDsPdfCta = _.get(data?.sourceInfos.sourceGroupData, 'enableDsPdfCta', false);
  const language = country[languageId];
  const url = `${REACT_APP_API}/buyer/public/${recordKey}/${language}/admin-documents/report-offer-reprise.pdf`;
  const appLang = Auth.preferredLanguage().toUpperCase();
  const entryStockDate = useSelector((state) => state.reduxRecords.data[recordId])?.supervisor?.entryStockDate?.date;
  const [queries, setQueries] = useState({
    firstName: _.get(clientInfo, 'firstName', ''),
    name: _.get(clientInfo, 'name', ''),
    email: _.get(clientInfo, 'email', ''),
    phone: _.get(clientInfo, 'phone', ''),
    buyerOffer: offer,
    validityOffer:
      (moment(entryStockDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') &&
        moment(entryStockDate).add(7, 'day').format('YYYY-MM-DD')) ||
      entryStockDate,
  });
  const recordCountryId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.countryId);
  const isUkFile = recordCountryId === 16;

  const verifEmpty = () => {
    let empty = false;
    Object.entries(queries).forEach((i) => {
      if (i[1] === '' || i[1] === null) empty = true;
    });
    return empty;
  };

  useEffect(() => {
    setDisable(verifEmpty());
  }, [queries]);

  const handleClick = async () => {
    _.map(queries, (value, key) => {
      queries[key] = value.trimEnd();
    });
    setLoading(true);
    try {
      if (infoChange) await ApiService('updateCustomerInfo', { recordId }, null, JSON.stringify(queries));
      await ApiService(
        'updateRecoveryOffer',
        { recordId },
        null,
        JSON.stringify({
          recoveryOffer: queries.buyerOffer,
          maxMileageEntryStockDate,
          validityOffer: queries.validityOffer,
          recoveryOfferComment: comment,
          hideReconCostsPdf,
          b2cValuePdf,
          useDsPdfLayout: enableDsPdfCta ? useDsPdfLayout : false,
          useSpoticarPdfLayout: enableSpoticarPdfCta ? useSpoticarPdfLayout : false,
        }),
      );
      try {
        const newTab = window.open();
        if (url) newTab.location.href = url;
      } catch {
        console.log('disable popup block');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { id } = e.target;
    let { value } = e.target;
    if (['buyerOffer'].includes(id)) {
      value = value.replace(',', '.').replace(/[^\d.\d]/g, '');
    }
    if (id !== 'buyerOffer' && value !== queries[id]) setInfoChange(true);
    const infos = { ...queries };
    infos[id] = value.trimStart();
    setQueries(infos);
  };

  const checkOffre = () => parseFloat(queries.buyerOffer) > parseFloat(_.get(data, 'supervisor.c2bOffer', 0));

  return (
    <Container fluid>
      {ClientInfoList.map((i) => (
        <Row key={i.titre}>
          <Col xs={12} md={5} lg={4}>
            <Label for={i.name} className="text-primary text-uppercase font-weight-light mt-3">
              <Translate code={i.name} />
            </Label>
            <div className="pseudo-input-currency">
              <input
                id={i.titre}
                inputMode={i.mode}
                pattern={i.pattern}
                name={i.name}
                type={i.type}
                className="form-control"
                placeholder={t(i.placeholder)}
                data-cy={i.name}
                value={i.titre === 'buyerOffer' ? queries[i.titre].replace('.', ',') : queries[i.titre]}
                onChange={(e) => handleChange(e)}
                disabled={Auth.roleViewerAccess()}
              />
              {i.titre === 'buyerOffer' && <div className="currency-wrapper">{currencySign()}</div>}
            </div>
            {i.titre === 'buyerOffer' && checkOffre() && (
              <p className="text-center text-danger">
                <Translate code="error_above_supervisor_pricing" />
              </p>
            )}
          </Col>
        </Row>
      ))}
      {!(recordCountryId === 7 && originId === 7) && (
        <Row>
          <Col xs={12} md={5} lg={4}>
            <Label for="maxMileageEntryStockDate" className="text-primary text-uppercase font-weight-light mt-3">
              <Translate code="maxMileageEntryStockDate" />
            </Label>
            <div className="pseudo-input-currency">
              <input
                id="maxMileageEntryStockDate"
                inputMode="tel"
                name="maxMileageEntryStockDate"
                type="number"
                className="form-control"
                placeholder={t('maxMileageEntryStockDate')}
                data-cy="maxMileageEntryStockDate"
                value={maxMileageEntryStockDate}
                onChange={(e) => setMaxMileageEntryStockDate(e.target.value)}
                disabled={Auth.roleViewerAccess()}
              />
              <div className="currency-wrapper">{isUkFile ? 'miles' : 'km'}</div>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={12} md={5} lg={4}>
          <Label for="validityOffer" className="text-primary text-uppercase font-weight-light mt-3">
            <Translate code="validityOffer" />
          </Label>
          <DatePicker
            className="form-control"
            name="validityOffer"
            id="validityOffer"
            onChange={(e) => {
              setQueries({
                ...queries,
                validityOffer: (e && moment(e).format('YYYY-MM-DD')) || '',
              });
            }}
            selected={queries.validityOffer ? moment(queries.validityOffer).toDate() : ''}
            dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
            placeholderText={t('long_date_placeholder')}
            locale={calendarLang[appLang]}
            autoComplete="off"
            showMonthDropdown
            showYearDropdown
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={5} lg={4}>
          <Label for="comment" className="text-primary text-uppercase font-weight-light mt-3">
            <Translate code="comment_buyer" />
          </Label>
          <div className="pseudo-input-currency">
            <textarea
              name="comment"
              id="comment"
              rows={4}
              className="form-control"
              onChange={(e) => setComment(e.target.value)}
              value={comment || ''}
              disabled={Auth.roleViewerAccess()}
            />
          </div>
        </Col>
      </Row>
      <Row className="pt-4 pl-3">
        <Switch
          isOn={hideReconCostsPdf}
          onColor="#273C78"
          id="hideReconCostsPdf"
          name="hideReconCostsPdf"
          handleToggle={(e) => setHideReconCostsPdf(e.target.checked)}
        />

        <Label for="hideReconCostsPdf" className="text-primary font-weight-light ml-2">
          <Translate code="hideDetailedReconCostsPdf" />
        </Label>
      </Row>
      <Row className="pl-3">
        <Switch
          isOn={b2cValuePdf}
          onColor="#273C78"
          id="b2cValuePdf"
          name="b2cValuePdf"
          handleToggle={(e) => setB2cValuePdf(e.target.checked)}
        />

        <Label for="b2cValuePdf" className="text-primary font-weight-light ml-2">
          <Translate code="b2cValuePdf" />
        </Label>
      </Row>
      {enableSpoticarPdfCta && (
        <Row className="pl-3">
          <Switch
            isOn={useSpoticarPdfLayout}
            onColor="#273C78"
            id="useSpoticarPdfLayout"
            name="useSpoticarPdfLayout"
            handleToggle={(e) => {
              setUseSpoticarPdfLayout(e.target.checked);
              setUseDsPdfLayout(false);
            }}
          />
          <Label for="useSpoticarPdfLayout" className="text-primary font-weight-light ml-2">
            <Translate code="generateSpoticarTradeInPdf" />
          </Label>
        </Row>
      )}
      {enableDsPdfCta && (
        <Row className="pl-3">
          <Switch
            isOn={useDsPdfLayout}
            onColor="#273C78"
            id="useDsPdfLayout"
            name="useDsPdfLayout"
            handleToggle={(e) => {
              setUseDsPdfLayout(e.target.checked);
              setUseSpoticarPdfLayout(false);
            }}
          />

          <Label for="useDsPdfLayout" className="text-primary font-weight-light ml-2">
            <Translate code="generateDsTradeInPdf" />
          </Label>
        </Row>
      )}
      {error && (
        <p className="text-center text-danger">
          <Translate code={error} />
        </p>
      )}
      <Row>
        <Col xs={12} md={5} lg={4} className="mt-5 mb-3 text-center">
          <button
            type="button"
            className={`btn ${disable === true || checkOffre() ? 'btn-4' : 'btn-1'}`}
            disabled={!(!checkOffre() && disable === false)}
            data-cy="generate_offer_pdf"
            onClick={() => handleClick()}
          >
            {loading && <Spinner color="white" />}
            <Translate code="generate_offer_pdf" />
          </button>
        </Col>
      </Row>
    </Container>
  );
};

TradeInOfferPage.propTypes = {
  data: PropTypes.shape().isRequired,
};

const NrmDebriefPage = ({ data }) => {
  const userCountry = Auth.country();
  const userContract = Auth.contract();
  const userRole = Auth.roleId();
  const reportType = _.get(data?.reportExpertise, 'reportId', null);
  const entryStockDate = _.get(data?.reportExpertise?.entryStockDate, 'date', null);
  const realPickUpAddress = _.get(data?.reportExpertise, 'realPickUpAddress', null);
  const mileageEntry = _.get(data?.reportExpertise, 'mileageEntry', null);
  const newCarVin = _.get(data?.reportExpertise, 'newCarVin', null);
  const comment = _.get(data?.reportExpertise, 'reportComment', null);
  const confirmationVehicleCondition = _.get(data?.reportExpertise, 'confirmationVehicleCondition', false);
  const commentVehicleCondition = _.get(data?.reportExpertise, 'commentVehicleCondition', null);
  const { recordId } = useParams();
  const isGermanSmartAgent = userCountry === 'DE' && userContract === 2 && userRole === 1;
  const isGermanSmartCentral = userCountry === 'DE' && userContract === 2 && userRole >= 2 && userRole <= 6;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingFinalization, setLoadingFinalization] = useState(false);
  const [error, setError] = useState();
  const [redirect, setRedirect] = useState();
  const [dataImages, setDataImages] = useState([]);
  const [addedImages, setAddedImages] = useState({ 24: [], 25: [], 26: [], 27: [], 28: [] });
  const [nbrImg, setNbrImg] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [firstTooltipOpen, setFirstTooltipOpen] = useState(false);
  const [secondTooltipOpen, setSecondTooltipOpen] = useState(false);
  const { nrmStatusId } = useGuaranteedPrice(recordId);
  const { waitingForCounterAppraisal } = NRM_SUB_STATUS;
  const [vehiculeConditionDesc, setVehiculeConditionDesc] = useState(false);
  const [yesIsClicked, setYesIsClicked] = useState(false);
  const [noIsClicked, setNoIsClicked] = useState(false);
  const [query, setQuery] = useState({
    recordId,
    reportType,
    comment,
    entryStockDate: entryStockDate ? moment(entryStockDate).format('YYYY-MM-DD') : '',
    realPickUpAddress,
    mileageEntry: mileageEntry || '',
    newCarVin,
    confirmationVehicleCondition,
    commentVehicleCondition: commentVehicleCondition ?? '',
  });
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  let fileCountry = _.get(data?.record, 'countryId', null);
  fileCountry = fileCountry !== null ? countries[fileCountry] : fileCountry;
  const appLang = Auth.preferredLanguage().toUpperCase();
  const originId = _.get(data?.record, 'originId', null);
  const isItalySol = data?.record?.countryId === 3 && (data?.record?.originId === 13 || data?.record?.originId === 14);
  const getImages = async () => {
    try {
      setIsLoading(true);
      const {
        data: { images },
      } = await ApiService('getFinalisationImages', { recordId });
      setDataImages(images);
    } catch (e) {
      setError('Error ', e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.reportExpertise?.reportId) {
      getImages();
    }
  }, []);

  useEffect(() => {
    const isReportType6 = parseInt(query.reportType, 10) === 6;
    const isReportType7Or8 = [7, 8].includes(parseInt(query.reportType, 10));
    const hasValidCommentVehicleCondition =
      isReportType6 && query.commentVehicleCondition && query.commentVehicleCondition.length >= 8;
    const hasValidComment = isReportType7Or8 && query.comment && _.trim(query.comment).length > 10;

    const otherCountries = !['BE', 'LU', 'AT', 'NL'].includes(userCountry);

    let isDisabled = true;

    if (isReportType7Or8 && hasValidComment) {
      isDisabled = false;
    } else if (isReportType6 && (hasValidCommentVehicleCondition || yesIsClicked)) {
      if (
        (userCountry === 'NL' && !addedImages[27]?.length) ||
        (['BE', 'LU', 'AT'].includes(userCountry) && (!addedImages[25]?.length || !addedImages[26]?.length))
      ) {
        isDisabled = true;
      } else if (otherCountries) {
        isDisabled = false;
      } else {
        isDisabled = false;
      }
    }

    setDisabled(isDisabled);

    if (parseInt(query.reportType, 10) !== 6 && query.entryStockDate && query.mileageEntry) {
      const q = query;
      delete q.entryStockDate;
      delete q.mileageEntry;
      setQuery({ ...q });
    }
    return () => true;
  }, [query, yesIsClicked, addedImages, userCountry]);

  const handleChange = (e) => {
    const { id } = e.target;
    const { value } = e.target;
    if (query) {
      const prev = { ...query };
      prev[id] = value;
      setQuery(prev);
    } else setQuery({ id: value });
  };

  function dataURItoBlob(dataURI) {
    const byteString =
      dataURI.split(',')[0].indexOf('base64') >= 0 ? atob(dataURI.split(',')[1]) : unescape(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  const uploadImage = async () => {
    const formdata = new FormData();
    const imageGroups = [24, 25, 26, 27, 28];
    let hasImages = false;

    imageGroups.forEach((grp) => {
      if (addedImages[grp] && addedImages[grp].length > 0) {
        addedImages[grp].forEach((base64Img, i) => {
          formdata.append(`files[${grp}][${i}]`, dataURItoBlob(base64Img), `file_${grp}_${i}.jpg`);
        });
        hasImages = true;
      }
    });

    if (hasImages) {
      await ApiService('updateFinalisationImage', { recordId }, null, formdata, null, 'image');
    }
  };

  const handleImage = async (e) => {
    const { type } = e.target.dataset;
    const image = await imageLoading(e.target.files[0]);
    setAddedImages((st) => {
      const group = st[type];
      group.push(image);
      return { ...st, [type]: group };
    });

    setNbrImg(nbrImg + 1);
  };
  const handleConfirmation = (isConfirmed) => {
    setVehiculeConditionDesc(!isConfirmed);
    setYesIsClicked(isConfirmed);
    setNoIsClicked(!isConfirmed);
    setQuery((prevQuery) => ({
      ...prevQuery,
      confirmationVehicleCondition: isConfirmed,
    }));
  };
  useEffect(() => {
    if (query && query.confirmationVehicleCondition === false) {
      setVehiculeConditionDesc(true);
    }
  }, [query, yesIsClicked, noIsClicked]);

  const handleClick = async () => {
    try {
      setLoadingFinalization(true);
      await uploadImage();
      const formatQ = query;
      if (formatQ.reportType === '6') formatQ.mileageEntry = parseInt(query.mileageEntry.replace(/[^0-9]/g, ''), 10);
      await updateReportInspection(formatQ);
    } catch (e) {
      setError('Error ', e);
    } finally {
      setLoadingFinalization(false);
      setRedirect(`/files/${recordId}`);
    }
  };
  const toggleImageOpen = (img) => {
    setSelectedImage(img);
    setImageOpen(true);
  };

  const removeImage = (type, img) => {
    setAddedImages((s) => {
      const imgs = s[type] ? s[type].filter((i) => i !== img) : [];
      return { ...s, [type]: imgs };
    });
    setNbrImg(nbrImg - 1);
  };
  const removeImageFromData = (type, img) => {
    setDataImages((s) => {
      const imgs = s[type] ? s[type].filter((i) => i !== img) : [];
      return { ...s, [type]: imgs };
    });
    setNbrImg(nbrImg - 1);
  };

  return (
    <Container fluid>
      {!data?.reportExpertise?.reportId || (isGermanSmartCentral && nrmStatusId < 60) ? (
        <>
          <Row className="page-Debrife mt-3">
            <Col xs={12} md={6} lg={8}>
              <Label className="text-primary text-left mb-3" data-testid="selectFinalisationOption">
                <Translate code="selectFinalisationOption" />
              </Label>
              {nrmStatusId === waitingForCounterAppraisal ? (
                <Label check className="mb-3 mr-1">
                  <Input
                    type="radio"
                    id="reportType"
                    value="8"
                    data-testid="reportType8"
                    onChange={(e) => handleChange(e)}
                    checked={parseInt(query.reportType, 10) === 8}
                  />{' '}
                  <span className="text-primary">
                    <Translate code="privateDidntBringItsUsedCar" />
                  </span>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    size="1x"
                    id="PrivateDidntBringItsUsedCar"
                    className="info-icon mt-1 ml-1"
                    onClick={() => setFirstTooltipOpen((prev) => !prev)}
                  />
                  <Tooltip
                    placement="bottom"
                    isOpen={firstTooltipOpen}
                    target="PrivateDidntBringItsUsedCar"
                    toggle={() => setFirstTooltipOpen((prev) => !prev)}
                  >
                    {t(`privateDidntBringItsUsedCarInformation`)}
                  </Tooltip>
                </Label>
              ) : (
                <>
                  <Label check className="mb-3 mr-1">
                    <Input
                      type="radio"
                      id="reportType"
                      value="6"
                      data-testid="reportType6"
                      onChange={(e) => handleChange(e)}
                      checked={parseInt(query.reportType, 10) === 6}
                    />{' '}
                    <span className="text-primary">
                      <Translate code="tradeInFinalized" />
                    </span>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      size="1x"
                      id="tradeInFinalizedInfo"
                      className="info-icon mt-1 ml-1"
                      onClick={() => setFirstTooltipOpen((prev) => !prev)}
                    />
                    <Tooltip
                      placement="bottom"
                      isOpen={firstTooltipOpen}
                      target="tradeInFinalizedInfo"
                      toggle={() => setFirstTooltipOpen((prev) => !prev)}
                    >
                      {t(`tradeInFinalizedInfo`)}
                    </Tooltip>
                  </Label>
                  <Label check className="mb-3 mr-1">
                    <Input
                      type="radio"
                      id="reportType"
                      value="7"
                      data-testid="reportType7"
                      onChange={(e) => handleChange(e)}
                      checked={parseInt(query.reportType, 10) === 7}
                    />{' '}
                    <span className="text-primary">
                      <Translate code="tradeInCanceledByCustomer" />
                    </span>
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      size="1x"
                      id="tradeInCanceledByCustomerInfo"
                      className="info-icon mt-1 ml-1"
                      onClick={() => setSecondTooltipOpen((prev) => !prev)}
                    />
                    <Tooltip
                      placement="bottom"
                      isOpen={secondTooltipOpen}
                      target="tradeInCanceledByCustomerInfo"
                      toggle={() => setSecondTooltipOpen((prev) => !prev)}
                    >
                      {t(`tradeInCanceledByCustomerInfo`)}
                    </Tooltip>
                  </Label>
                </>
              )}
            </Col>
          </Row>
          <hr />
          {parseInt(query.reportType, 10) === 6 && (
            <>
              <Row className="mt-3">
                <Col xs={12} md={12} lg={12}>
                  <Label className="text-primary text-left font-weight-bold">
                    <Translate code={nrmFinalisationDocumentVar[fileCountry]} />
                  </Label>
                </Col>
                <Col xs={12} md={12} lg={12}>
                  <div className="d-flex flex-sm-row flex-column gap-2">
                    {isGermanSmartCentral && data?.reportExpertise?.reportId && (
                      <>
                        {dataImages[24]?.length > 0 &&
                          dataImages[24]?.map((img) => (
                            <div className="d-flex mb-3">
                              <div
                                key={uniqueId()}
                                onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                                onKeyDown={() => {}}
                                role="presentation"
                              >
                                <img
                                  src={`data:image/png;base64,${img}`}
                                  alt=""
                                  style={{ objectFit: 'cover' }}
                                  className="mr-1"
                                  width="150"
                                  height="100"
                                />
                              </div>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                onClick={(e) => removeImageFromData(e.currentTarget.dataset.type, img)}
                                className="debrief-delete-btn"
                                size="1x"
                                data-type="24"
                              />
                            </div>
                          ))}
                      </>
                    )}

                    {addedImages[24].length > 0 &&
                      addedImages[24].map((img) => (
                        <div className="d-flex mb-3">
                          <div
                            key={uniqueId()}
                            onClick={() => toggleImageOpen(img)}
                            onKeyDown={() => {}}
                            role="presentation"
                          >
                            <img
                              src={img}
                              alt=""
                              style={{ objectFit: 'cover' }}
                              className="mx-2"
                              width="150"
                              height="100"
                            />
                          </div>
                          <FontAwesomeIcon
                            icon={faTimesCircle}
                            onClick={(e) => removeImage(e.currentTarget.dataset.type, img)}
                            className="debrief-delete-btn"
                            size="1x"
                            data-type="24"
                          />
                        </div>
                      ))}
                    {imageOpen && <Lightbox mainSrc={selectedImage} onCloseRequest={() => setImageOpen(!imageOpen)} />}
                  </div>
                </Col>
                <Col xs={12} md={12} lg={12}>
                  <Label className="text-primary text-left mt-3" for="greyCardPicture">
                    <Translate code="nrmFinalisationDocuments" />
                  </Label>
                </Col>
                <Col xs="4" md="3" lg="2">
                  <div type="button" className="btn btn-block btn-value h-100" data-testid="finalisationImage">
                    <label htmlFor="finalisation_image" className="button-camera circle">
                      <FontAwesomeIcon icon={faCamera} />
                      <input
                        type="file"
                        id="finalisation_image"
                        accept="image/*"
                        capture="camera"
                        onChange={handleImage}
                        data-cy="add_image_camera"
                        data-type="24"
                        disabled={Auth.roleViewerAccess()}
                        multiple
                      />
                    </label>
                  </div>
                </Col>
              </Row>
              {isItalySol && (
                <Row className="mt-3">
                  <Col xs={12} md={12} lg={12}>
                    <Label className="text-primary text-left font-weight-bold">
                      <Translate code="temporaryOwnershipPosDocument" />
                    </Label>
                  </Col>
                  <Col xs={12} md={12} lg={12}>
                    <div className="d-flex flex-sm-row flex-column gap-2 mt-2">
                      <>
                        {dataImages[28]?.length > 0 &&
                          dataImages[28]?.map((img) => (
                            <div className="d-flex mb-3">
                              <div
                                key={uniqueId()}
                                onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                                onKeyDown={() => {}}
                                role="presentation"
                              >
                                <img
                                  src={`data:image/png;base64,${img}`}
                                  alt=""
                                  style={{ objectFit: 'cover' }}
                                  className="mr-1"
                                  width="150"
                                  height="100"
                                />
                              </div>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                onClick={(e) => removeImageFromData(e.currentTarget.dataset.type, img)}
                                className="debrief-delete-btn"
                                size="1x"
                                data-type="28"
                              />
                            </div>
                          ))}
                      </>

                      {addedImages[28].length > 0 &&
                        addedImages[28].map((img) => (
                          <div className="d-flex mb-3">
                            <div
                              key={uniqueId()}
                              onClick={() => toggleImageOpen(img)}
                              onKeyDown={() => {}}
                              role="presentation"
                            >
                              <img
                                src={img}
                                alt=""
                                style={{ objectFit: 'cover' }}
                                className="mx-2"
                                width="150"
                                height="100"
                              />
                            </div>
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              onClick={(e) => removeImage(e.currentTarget.dataset.type, img)}
                              className="debrief-delete-btn"
                              size="1x"
                              data-type="28"
                            />
                          </div>
                        ))}
                      {imageOpen && (
                        <Lightbox mainSrc={selectedImage} onCloseRequest={() => setImageOpen(!imageOpen)} />
                      )}
                    </div>
                  </Col>
                  <Col xs={12} md={12} lg={12}>
                    <Label className="text-primary text-left mt-3" for="greyCardPicture">
                      <Translate code="nrmFinalisationDocuments" />
                    </Label>
                  </Col>
                  <Col xs="4" md="3" lg="2">
                    <div
                      type="button"
                      className="btn btn-block btn-value h-100"
                      data-testid="temporaryOwnershipPosDocument"
                    >
                      <label htmlFor="temporaryOwnershipPosDocument" className="button-camera circle">
                        <FontAwesomeIcon icon={faCamera} />
                        <input
                          type="file"
                          id="temporaryOwnershipPosDocument"
                          accept="image/*"
                          capture="camera"
                          onChange={handleImage}
                          data-cy="add_image_camera"
                          data-type="28"
                          disabled={Auth.roleViewerAccess()}
                          multiple
                        />
                      </label>
                    </div>
                  </Col>
                </Row>
              )}
              {(userCountry === 'BE' || userCountry === 'LU' || userCountry === 'AT') && (
                <>
                  <Row className="mt-3">
                    <Col xs={12} md={8} lg={5}>
                      <Label className="text-primary text-left font-weight-bold">
                        <Translate code="nrmProofOfTransaction" />
                      </Label>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                      <div className="d-flex flex-sm-row flex-column gap-2">
                        {addedImages[25].length > 0 &&
                          addedImages[25].map((img) => (
                            <div className="d-flex mb-3">
                              <div
                                key={uniqueId()}
                                onClick={() => toggleImageOpen(img)}
                                onKeyDown={() => {}}
                                role="presentation"
                              >
                                <img
                                  src={img}
                                  alt=""
                                  style={{ objectFit: 'cover' }}
                                  className="mx-2"
                                  width="150"
                                  height="100"
                                />
                              </div>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                onClick={(e) => removeImage(e.target.dataset.type, img)}
                                className="debrief-delete-btn"
                                size="1x"
                                data-type="25"
                              />
                            </div>
                          ))}
                        {imageOpen && (
                          <Lightbox mainSrc={selectedImage} onCloseRequest={() => setImageOpen(!imageOpen)} />
                        )}
                      </div>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                      <Label className="text-primary text-left mt-3" for="greyCardPicture">
                        <Translate code="nrmFinalisationDocuments" />
                      </Label>
                    </Col>
                    <Col xs="4" md="3" lg="2">
                      <div
                        type="button"
                        className="btn btn-block btn-value h-100"
                        data-testid="proofOfTransactionImage"
                      >
                        <label htmlFor="proof_of_transaction_image" className="button-camera circle">
                          <FontAwesomeIcon icon={faCamera} />
                          <input
                            type="file"
                            id="proof_of_transaction_image"
                            accept="image/*"
                            capture="camera"
                            onChange={handleImage}
                            data-cy="add_image_camera"
                            data-type="25"
                            disabled={Auth.roleViewerAccess()}
                            multiple
                          />
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={12} md={8} lg={5}>
                      <Label className="text-primary text-left font-weight-bold">
                        <Translate code="nrmCertificationOfConformity" />
                      </Label>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                      <div className="d-flex flex-sm-row flex-column gap-2">
                        {addedImages[26].length > 0 &&
                          addedImages[26].map((img) => (
                            <div className="d-flex mb-3">
                              <div
                                key={uniqueId()}
                                onClick={() => toggleImageOpen(img)}
                                onKeyDown={() => {}}
                                role="presentation"
                              >
                                <img
                                  src={img}
                                  alt=""
                                  style={{ objectFit: 'cover' }}
                                  className="mx-2"
                                  width="150"
                                  height="100"
                                />
                              </div>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                onClick={(e) => removeImage(e.target.dataset.type, img)}
                                className="debrief-delete-btn"
                                size="1x"
                                data-type="26"
                              />
                            </div>
                          ))}
                        {imageOpen && (
                          <Lightbox mainSrc={selectedImage} onCloseRequest={() => setImageOpen(!imageOpen)} />
                        )}
                      </div>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                      <Label className="text-primary text-left mt-3" for="greyCardPicture">
                        <Translate code="nrmFinalisationDocuments" />
                      </Label>
                    </Col>
                    <Col xs="4" md="3" lg="2">
                      <div
                        type="button"
                        className="btn btn-block btn-value h-100"
                        data-testid="certificationOfConformityImage"
                      >
                        <label htmlFor="certification_of_conformity_image" className="button-camera circle">
                          <FontAwesomeIcon icon={faCamera} />
                          <input
                            type="file"
                            id="certification_of_conformity_image"
                            accept="image/*"
                            capture="camera"
                            onChange={handleImage}
                            data-cy="add_image_camera"
                            data-type="26"
                            multiple
                            disabled={Auth.roleViewerAccess()}
                          />
                        </label>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              {userCountry === 'NL' && (
                <Row className="mt-3">
                  <Col xs={12} md={8} lg={5}>
                    <Label className="text-primary text-left font-weight-bold">
                      <Translate code="nrmCertificationOfIndemnification" />
                    </Label>
                  </Col>
                  <Col xs={12} md={12} lg={12}>
                    <div className="d-flex flex-sm-row flex-column gap-2">
                      {addedImages[27].length > 0 &&
                        addedImages[27].map((img) => (
                          <div className="d-flex mb-3">
                            <div
                              key={uniqueId()}
                              onClick={() => toggleImageOpen(img)}
                              onKeyDown={() => {}}
                              role="presentation"
                            >
                              <img
                                src={img}
                                alt=""
                                style={{ objectFit: 'cover' }}
                                className="mx-2"
                                width="150"
                                height="100"
                              />
                            </div>
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              onClick={(e) => removeImage(e.target.dataset.type, img)}
                              className="debrief-delete-btn"
                              size="1x"
                              data-type="27"
                            />
                          </div>
                        ))}
                      {imageOpen && (
                        <Lightbox mainSrc={selectedImage} onCloseRequest={() => setImageOpen(!imageOpen)} />
                      )}
                    </div>
                  </Col>
                  <Col xs={12} md={12} lg={12}>
                    <Label className="text-primary text-left mt-3" for="greyCardPicture">
                      <Translate code="nrmFinalisationDocuments" />
                    </Label>
                  </Col>
                  <Col xs="4" md="3" lg="2">
                    <div
                      type="button"
                      className="btn btn-block btn-value h-100"
                      data-testid="certificationOfIndemnificationImage"
                    >
                      <label htmlFor="certification_of_indemnification_image" className="button-camera circle">
                        <FontAwesomeIcon icon={faCamera} />
                        <input
                          type="file"
                          id="certification_of_indemnification_image"
                          accept="image/*"
                          capture="camera"
                          onChange={handleImage}
                          data-cy="add_image_camera"
                          data-type="27"
                          multiple
                          disabled={Auth.roleViewerAccess()}
                        />
                      </label>
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mt-3">
                <Col xs={12} md={5} lg={4} data-testid="realEntryStockDate">
                  <Label className="text-primary text-left" for="entryStockDate">
                    <Translate code="realEntryStockDate" />
                  </Label>
                  <DatePicker
                    className="form-control"
                    name="entryStockDate"
                    id="entryStockDate"
                    onChange={(e) => setQuery({ ...query, entryStockDate: moment(e).format('YYYY-MM-DD') })}
                    selected={(query?.entryStockDate && new Date(query?.entryStockDate)) || ''}
                    locale={calendarLang[appLang]}
                    dateFormat="dd MMMM yyyy"
                    placeholderText={t('DD/MM/YYYY')}
                    autoComplete="off"
                    disabled={Auth.roleViewerAccess()}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={12} md={5} lg={4} data-testid="realPickUpAddress">
                  <Label className="text-primary text-left" for="realPickUpAddress">
                    <Translate code="realPickUpAddress" />
                  </Label>
                  <Input
                    placeholder="address"
                    type="text"
                    name="realPickUpAddress"
                    id="realPickUpAddress"
                    disabled={Auth.roleViewerAccess()}
                    value={query.realPickUpAddress ? query.realPickUpAddress : ''}
                    className="rounded"
                    onChange={(e) => handleChange(e)}
                    required
                    minLength={5}
                  />
                  {query.realPickUpAddress && query.realPickUpAddress.length < 5 && (
                    <p className="text-danger">{t('addressLimitCharacterNumber')}</p>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={12} md={5} lg={4} data-testid="mileageEntry">
                  <Label className="text-primary text-left" for="mileageEntry">
                    <Translate code="mileageEntry" />
                  </Label>
                  <Input
                    placeholder="90 000"
                    type="text"
                    name="mileageEntry"
                    id="mileageEntry"
                    disabled={Auth.roleViewerAccess()}
                    value={query.mileageEntry}
                    className="alternate"
                    onChange={(e) => {
                      let { value } = e.target;
                      value = value.replace(/[^0-9]/g, '');
                      if (value !== '') {
                        if (value.length > 6) return;
                        setQuery({ ...query, mileageEntry: value });
                      } else setQuery({ ...query, mileageEntry: '' });
                    }}
                    rows={4}
                  />
                </Col>
              </Row>
              {fileCountry === 'FR' && (originId === 13 || originId === 14) && (
                <Row className="mt-3">
                  <Col xs={12} md={5} lg={4} data-testid="newCarVin">
                    <Label className="text-primary text-left" for="newCarVin">
                      <Translate code="newCarVin" />
                    </Label>
                    <Input
                      placeholder="vin"
                      type="text"
                      name="newCarVin"
                      id="newCarVin"
                      disabled={Auth.roleViewerAccess()}
                      value={query.newCarVin ? query.newCarVin : ''}
                      className="alternate"
                      onChange={(e) => handleChange(e)}
                      required
                      minLength={17}
                      maxLength={17}
                    />
                    {query.newCarVin && query.newCarVin.length !== 17 && (
                      <p className="text-danger">{t('vinLimitCharacterNumber')}</p>
                    )}
                  </Col>
                </Row>
              )}
            </>
          )}
          {[6, 7, 8].includes(parseInt(query.reportType, 10)) && (
            <>
              <Row className="mt-3">
                <Col xs={12} md={5} lg={4} data-testid="comment">
                  <Label className="text-primary text-left" for="comment">
                    {parseInt(query.reportType, 10) === 6 && <Translate code="commentNrmFinalisation" />}
                    {[7, 8].includes(parseInt(query.reportType, 10)) && (
                      <Translate code="commentNrmFinalisationCanceled" />
                    )}
                  </Label>
                  <Input
                    type="textarea"
                    name="comment"
                    id="comment"
                    className="rounded"
                    rows={4}
                    onChange={(e) => handleChange(e)}
                    value={(query.comment && query.comment) || ''}
                    disabled={Auth.roleViewerAccess()}
                  />
                </Col>
              </Row>
            </>
          )}
          {parseInt(query.reportType, 10) === 6 && (
            <>
              <Row className="mt-3">
                <Col xs={12} md={5} lg={4}>
                  <Label className="text-primary text-left" for="confirmationVehicleCondition">
                    <Translate code="confirmationVehicleCondition" />
                  </Label>
                  {!Auth.roleViewerAccess() && (
                    <div data-testid="confirmationVehicleCondition" className="question-select">
                      <Row>
                        <Col xs="6" sm="6" md="4" lg="6" className="mb-3">
                          <button
                            type="button"
                            className={`btn btn-block btn-value h-100 ${yesIsClicked === true ? 'selected' : ''}`}
                            data-testid="yes"
                            onClick={() => handleConfirmation(true)}
                          >
                            {t('yes')}
                          </button>
                        </Col>
                        <Col xs="6" sm="6" md="4" lg="6" className="mb-3">
                          <button
                            type="button"
                            className={`btn btn-block btn-value h-100 ${noIsClicked === true ? 'selected' : ''}`}
                            data-testid="no"
                            onClick={() => handleConfirmation(false)}
                          >
                            {t('no')}
                          </button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Col>
              </Row>
            </>
          )}
          {parseInt(query.reportType, 10) === 6 && vehiculeConditionDesc && (
            <>
              <Row className="mt-3">
                <Col xs={12} md={5} lg={4} data-testid="commentVehicleCondition">
                  <Label className="text-primary text-left" for="commentVehicleCondition">
                    <Translate code="commentVehicleCondition" />
                  </Label>
                  <Input
                    type="textarea"
                    name="commentVehicleCondition"
                    id="commentVehicleCondition"
                    className="rounded"
                    rows={4}
                    onChange={(e) => handleChange(e)}
                    value={query.commentVehicleCondition}
                    disabled={Auth.role() === 'viewer'}
                  />
                </Col>
              </Row>
            </>
          )}
          {[6, 7, 8].includes(parseInt(query.reportType, 10)) && (
            <>
              <Row className="mt-3">
                {error && (
                  <p className="ml-2 text-danger">
                    <Translate code={error} />
                  </p>
                )}
                <Col xs={12} md={5} lg={4}>
                  {loadingFinalization && <Spinner size="sm" />}
                  {!isGermanSmartAgent && (
                    <button
                      type="button"
                      className={`btn btn-block mb-3 ${disabled || isGermanSmartAgent ? 'btn-4' : 'btn-1'}`}
                      data-testid="validateFinalisationReport"
                      onClick={() => handleClick()}
                      disabled={disabled || isGermanSmartAgent}
                    >
                      {t('validate')}
                    </button>
                  )}
                  {isGermanSmartAgent && (
                    <button
                      type="button"
                      className={`btn btn-block mb-3 ${disabled ? 'btn-4' : 'btn-1'}`}
                      onClick={() => handleClick()}
                      disabled={disabled}
                    >
                      {t('finalisationFilled')}
                    </button>
                  )}
                </Col>
              </Row>
            </>
          )}
        </>
      ) : (
        <>
          <Row className="mt-5">
            <Col xs={12} md={12} lg={12}>
              {parseInt(query.reportType, 10) === 6 && (
                <Label className="text-primary text-left font-weight-bold" for="nrmFinalisedTitle">
                  <Translate code="nrmFinalisedTitle" />
                </Label>
              )}
              {parseInt(query.reportType, 10) === 7 && (
                <Label className="text-primary text-left font-weight-bold" for="nrmFinalisationDeclinedTitle">
                  <Translate code="nrmFinalisationDeclinedTitle" />
                </Label>
              )}
              {parseInt(query.reportType, 10) === 8 && (
                <Label className="text-primary text-left font-weight-bold" for="notShowUsedCarTitle">
                  <Translate code="notShowUsedCarTitle" />
                </Label>
              )}
            </Col>
          </Row>
          {parseInt(query.reportType, 10) === 6 && (
            <Row className="mt-3">
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left" for="greyCardPicture">
                  <Translate code="documentsOfFinalization" />
                </Label>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <div>
                  {isLoading && <Spinner size="sm" />}
                  <div className="d-flex flex-column gap-2">
                    <Col xs={12} md={12} lg={12}>
                      <Label className="text-primary text-left font-weight-bold">
                        <Translate code={nrmFinalisationDocumentVar[fileCountry]} />
                      </Label>
                      <Row className="mt-3">
                        {dataImages[24]?.length &&
                          dataImages[24]?.map((img) => (
                            <div
                              key={uniqueId()}
                              onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                              onKeyDown={() => {}}
                              role="presentation"
                            >
                              <img
                                src={`data:image/png;base64,${img}`}
                                alt=""
                                style={{ objectFit: 'cover' }}
                                className="mr-1"
                                width="150"
                                height="100"
                              />
                            </div>
                          ))}
                      </Row>
                    </Col>
                    {(userCountry === 'BE' || userCountry === 'LU' || userCountry === 'AT') && (
                      <>
                        {' '}
                        <Col xs={12} md={12} lg={12}>
                          <Label className="text-primary text-left font-weight-bold">
                            <Translate code="nrmProofOfTransaction" />
                          </Label>
                          <Row className="mt-3">
                            {dataImages[25]?.length &&
                              dataImages[25]?.map((img) => (
                                <div
                                  key={uniqueId()}
                                  onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                                  onKeyDown={() => {}}
                                  role="presentation"
                                >
                                  <img
                                    src={`data:image/png;base64,${img}`}
                                    alt=""
                                    style={{ objectFit: 'cover' }}
                                    className="mr-1"
                                    width="150"
                                    height="100"
                                  />
                                </div>
                              ))}
                          </Row>
                        </Col>
                        <Col xs={12} md={12} lg={12}>
                          <Label className="text-primary text-left font-weight-bold">
                            <Translate code="nrmCertificationOfConformity" />
                          </Label>
                          <Row className="mt-3">
                            {dataImages[26]?.length &&
                              dataImages[26]?.map((img) => (
                                <div
                                  key={uniqueId()}
                                  onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                                  onKeyDown={() => {}}
                                  role="presentation"
                                >
                                  <img
                                    src={`data:image/png;base64,${img}`}
                                    alt=""
                                    style={{ objectFit: 'cover' }}
                                    className="mr-1"
                                    width="150"
                                    height="100"
                                  />
                                </div>
                              ))}
                          </Row>
                        </Col>
                      </>
                    )}
                    {userCountry === 'NL' && (
                      <Col xs={12} md={12} lg={12}>
                        <Label className="text-primary text-left font-weight-bold">
                          <Translate code="nrmCertificationOfIndemnification" />
                        </Label>
                        <Row className="mt-3">
                          {dataImages[27]?.length &&
                            dataImages[27]?.map((img) => (
                              <div
                                key={uniqueId()}
                                onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                                onKeyDown={() => {}}
                                role="presentation"
                              >
                                <img
                                  src={`data:image/png;base64,${img}`}
                                  alt=""
                                  style={{ objectFit: 'cover' }}
                                  className="mr-1"
                                  width="150"
                                  height="100"
                                />
                              </div>
                            ))}
                        </Row>
                      </Col>
                    )}
                    {isItalySol && (
                      <Col xs={12} md={12} lg={12}>
                        <Label className="text-primary text-left font-weight-bold">
                          <Translate code="temporaryOwnershipPosDocument" />
                        </Label>
                        <div>
                          {isLoading && <Spinner size="sm" />}
                          <Row className="mt-3">
                            {dataImages[28]?.length &&
                              dataImages[28]?.map((img) => (
                                <div
                                  key={uniqueId()}
                                  onClick={() => toggleImageOpen(`data:image/png;base64,${img}`)}
                                  onKeyDown={() => {}}
                                  role="presentation"
                                >
                                  <img
                                    src={`data:image/png;base64,${img}`}
                                    alt=""
                                    style={{ objectFit: 'cover' }}
                                    className="mr-1"
                                    width="150"
                                    height="100"
                                  />
                                </div>
                              ))}
                          </Row>
                        </div>
                      </Col>
                    )}

                    {imageOpen && <Lightbox mainSrc={selectedImage} onCloseRequest={() => setImageOpen(!imageOpen)} />}
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {query.entryStockDate && (
            <Row className="mt-3">
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">
                  <Translate code="realEntryStockDate" />
                </Label>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">{query.entryStockDate}</Label>
              </Col>
            </Row>
          )}
          {query.realPickUpAddress && (
            <Row className="mt-3">
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">
                  <Translate code="realPickUpAddress" />
                </Label>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">{query.realPickUpAddress}</Label>
              </Col>
            </Row>
          )}
          {query.mileageEntry && (
            <Row className="mt-3">
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">
                  <Translate code="mileageEntry" />
                </Label>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">{query.mileageEntry}</Label>
              </Col>
            </Row>
          )}
          {query.newCarVin && (
            <Row className="mt-3">
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">
                  <Translate code="newCarVin" />
                </Label>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left">{query.newCarVin}</Label>
              </Col>
            </Row>
          )}
          {query.comment && (
            <Row className="mt-3">
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left" for="greyCardPicture">
                  <Translate code="commentNrmFinalisation" />
                </Label>
              </Col>
              <Col xs={12} md={12} lg={12}>
                <Label className="text-primary text-left" for="greyCardPicture">
                  {(query.comment && query.comment) || ''}
                </Label>
              </Col>
            </Row>
          )}
        </>
      )}
      {redirect && <Redirect to={redirect} />}
    </Container>
  );
};

NrmDebriefPage.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Finalising);
